// extracted by mini-css-extract-plugin
export default {"logo":"page404_styles_logo__BYUrF"};